<template>
  <canvas ref="qrcode"></canvas>
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'QRCode',
  props: {
    text: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      default: 128
    },
    height: {
      type: Number,
      default: 128
    }
  },
  mounted() {
    this.generateQRCode()
  },
  methods: {
    generateQRCode() {
      QRCode.toCanvas(this.$refs.qrcode, this.text, {
        width: this.width,
        height: this.height
      }, function (error) {
        if (error) console.error(error)
        console.log('success!')
      })
    }
  }
}
</script>

<style scoped>
</style>
